<div class="outer-container">

  <lib-title-bar [crumbs]="[{ 'label': 'Transactions' }]">
  </lib-title-bar>

  <app-transaction-log-filters
    [filter]="filter"
    (filterChanged)="filterChanged.emit($event)">
  </app-transaction-log-filters>

  <div class="table-actions-bar">
    <lib-action-button label="Export" (click)="this.exportToCsv.emit()" [disabled]="exportButtonDisabled()"
      fontImage="far fa-file-export fa-lg" [kind]="ActionButtonKind.SECONDARY">
    </lib-action-button>
  </div>

  <div class="table-container">
    @if (true) {
      <app-transactions-table
        [rowsData]="rowsData"
        [rowsDataLoading]="loading"
        [rowsDataError]="error"
        rowsDataErrorMessage="Error Loading Transactions"
        rowsDataEmptyMessage="No Transactions Found"
        [rowsDataShowWhileLoading]="true"
        selectedRowProperty="token"
        [sorting]="sorting"
        (sortingChanged)="onSortingChanged($event)"
        [pager]="pager"
        (pageChanged)="pageChanged.emit($event)"
        (rowSelected)="onRowSelected($event)">
      </app-transactions-table>
    }
    @if (exportLoading) {
      <lib-busy-indicator>
      </lib-busy-indicator>
    }
  </div>

</div>


